import React, { useState, useRef } from "react";
import {
  TooltipContainer,
  TooltipTextContainer,
  IconContainer,
  ToolTipWrapper,
} from "./Tooltip.styles";
import { Body6RegularTypography } from "../../primitives/Typography/typographyVariants";
import { colorPalette } from "../../theme/colors";
import { useClickOutside } from "../../hooks/useClickOutside";
import { TooltipProps } from "./Tooltip.types";
import { IMAGE_PREFIX } from "../../utils/constants";

export const Tooltip: React.FC<TooltipProps> = ({
  component,
  variant = "left",
  children,
  onClick,
  triggerOnHover = false,
}) => {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  // Function to handle visibility based on hover
  const handleMouseEnter = () => {
    if (triggerOnHover) {
      setVisible(true);
    }
  };

  // Function to hide the tooltip when mouse leaves
  const handleMouseLeave = () => {
    if (triggerOnHover) {
      setVisible(false);
    }
  };
  const handleClick = (isVisible: boolean) => {
    if (!triggerOnHover) {
      setVisible(isVisible);
    }
    if (onClick && isVisible) {
      onClick();
    }
  };

  useClickOutside(tooltipRef, () => handleClick(false));

  return (
    <ToolTipWrapper ref={tooltipRef}>
      <div
        onClick={(e) => {
          e.stopPropagation();
          handleClick(true);
        }}
        onMouseEnter={handleMouseEnter} // Handle hover start
        onMouseLeave={handleMouseLeave} // Handle hover end
      >
        {children}
      </div>
      {visible && (
        <TooltipContainer variant={variant}>
          {(variant === "left" || variant === "top") && (
            <IconContainer
              src={
                variant === "top"
                  ? `${IMAGE_PREFIX}Tooltip.png`
                  : `${IMAGE_PREFIX}TooltipRight.png`
              }
              variant={variant}
            />
          )}
          <TooltipTextContainer>
            {typeof component === "string" ? (
              <Body6RegularTypography color={colorPalette.popWhite[500]}>
                {component}
              </Body6RegularTypography>
            ) : (
              <>{component}</>
              // If the component is a React element, render it directly
            )}
          </TooltipTextContainer>
          {(variant === "right" || variant === "bottom") && (
            <IconContainer
              src={
                variant === "bottom"
                  ? `${IMAGE_PREFIX}Tooltip.png`
                  : `${IMAGE_PREFIX}TooltipRight.png`
              }
              variant={variant}
            />
          )}
        </TooltipContainer>
      )}
    </ToolTipWrapper>
  );
};
